import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";

interface Props extends WidgetProps {
    fields: {
        cssClass: string;
    };
}

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        div[class^="GridOffset"] {
            max-width: 100%;
        }
    `,
};

export interface CustomContainerStyles {
    container?: InjectableCss;
}

export const CustomContainerStyles: CustomContainerStyles = {
    container: {
        css: css`
            padding: 0;
            max-width: 1440px;
            margin: 0 auto;
            .homeBottomBannerWrapper {
                padding: 50px calc(2% + 25px);
                background: ${getColor("common.accent")};
            }
            .notfoundheading {
                margin-bottom: 20px;
                color: ${getColor("primary")};
            }
            .homeBottomBanner {
                background: #fff;
                box-shadow: 2px 0px 10px 5px #00000029;
                display: flex;
                flex-direcion: row;
                .imgCol {
                    width: 50%;
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding-left: 20px;
                                `,
                                null,
                            ],
                            "max",
                        );
                    }}
                    img {
                        height: 100%;
                    }
                }
                .txtCol {
                    width: 50%;
                    padding: 30px;
                    p:last-child {
                        margin: 0 30px 0 0;
                    }
                    img {
                        max-width: 150px;
                    }
                }
            }
            &.grayBg {
                background: ${getColor("common.accent")};
                padding: 40px;
                margin-bottom: 23px;
                &.pdp {
                    padding: 10px;
                    margin-top: 10px;
                    .atcQty {
                        div[class^="GridOffset"] {
                            max-width: 100%;
                            margin: 0;
                            > div[class^="GridItemStyle"] {
                                padding: 0;
                                button[data-test-selector="addProductToCart"] {
                                    margin-left: 10px;
                                    width: calc(100% - 10px);
                                    ${({ theme }) => {
                                        return breakpointMediaQueries(theme, [
                                            null,
                                            null,
                                            null,
                                            css`
                                                padding: 0 10px;
                                                span {
                                                    font-size: 13px;
                                                }
                                            `,
                                            null,
                                        ]);
                                    }}
                                }
                            }
                        }
                    }
                    button[data-test-selector="productDetails_addToList"] {
                        margin-top: 10px;
                        background: #fff;
                    }
                }
                &.pdpCarousel {
                    padding: 0px;
                    h2 {
                        padding-top: 15px;
                    }
                    div[data-test-selector^="productCarousel"] {
                        padding-bottom: 30px;
                    }
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            padding: 10px;
                        `,
                        css`
                            padding: 10px;
                        `,
                        css`
                            padding: 20px;
                        `,
                        css`
                            padding: 20px;
                        `,
                        css`
                            padding: 40px;
                        `,
                    ]);
                }}
                [data-test-selector="rows"] {
                    margin-bottom: 20px;
                }
                &.myAccountPage {
                    > div > div > div[class^="GridOffset"] {
                        max-width: 100%;
                        margin: 0;
                    }
                }
            }
            &.changeCustomerContainer {
                span[data-test-selector="changeCustomerShipToSelector-selectedText"],
                span[data-test-selector="changeCustomerBillToSelector-selectedText"] {
                    padding-right: 40px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        `,
    },
};

const styles = CustomContainerStyles;

const CustomContainer: React.FC<Props> = ({ fields: { cssClass }, id }: Props) => {
    return (
        <StyledWrapper className={cssClass} {...styles.container} data-test-selector="CustomContainer">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomContainer,
    definition: {
        displayName: "Custom Container",
        group: "Common",
        fieldDefinitions: [
            {
                name: "cssClass",
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
